import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/shared/ui/button"
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from "@/shared/ui/drawer"
import { X } from "lucide-react";
import { formatTimestamp } from "@/shared/lib/appHelpers"
import Report from '@/features/report-detail/ReportDetailPage';
import { useCurrentTool } from "@/shared/hooks/useCurrentTool"
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedReport } from "@/store/slices/ReportsSlice"
import { reportsApi } from '@/api/rtk/reportsApi'

function ReportDrawer({
  isDrawerOpen,
  setDrawerOpen,
}) {
  const dispatch = useDispatch();
  const report = useSelector(selectSelectedReport);
  const { currentToolFields, generation_name } = useCurrentTool();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isDrawerOpen || !report?.id || !currentToolFields?.length) return undefined;
    const request = dispatch(
      reportsApi.endpoints.getReport.initiate({ id: report.id, currentToolFields })
    );
    return () => request.unsubscribe();
  }, [dispatch, isDrawerOpen, report?.id, currentToolFields]);

  if (!report?.id) return null;

  return (
    <Drawer direction="right" open={isDrawerOpen} onOpenChange={setDrawerOpen}>
      <DrawerContent className="md:max-w-[604px] p-6 ml-auto h-full bg-white overflow-y-scroll overflow-x-hidden scroll-smooth">
        <DrawerHeader className="relative flex justify-between items-center p-0">
          <div>
            <DrawerTitle
              className="text-black text-[20px] font-medium space-x-1 cursor-pointer capitalize text-left"
              onClick={() => navigate(`${location.pathname}/${report.id}`)}
            >
              {report.fields?.[currentToolFields?.[0].name]}
            </DrawerTitle>
            <DrawerDescription>
              {generation_name} {report.row_number}, {formatTimestamp(report.created_at, "d/m/y")}
            </DrawerDescription>
          </div>
          <DrawerClose className="">
            <Button variant="ghost" size="icon" className="h-6 w-6">
              <X className="h-6 w-6 text-black" />
              <span className="sr-only">Close</span>
            </Button>
          </DrawerClose>
        </DrawerHeader>
        <div className="">
          <Report isDrawer={true} />
        </div>
      </DrawerContent>
    </Drawer>
  );
}

export default ReportDrawer;
